import axios from 'axios';
// config
import { HOST_API_KEY } from '../config';

const axiosInstance = axios.create({
  baseURL: HOST_API_KEY,
  headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
  },
  responseType: 'json'
});

axiosInstance.interceptors.request.use(
  (config) => {

    const token = localStorage.getItem('accessToken');
    const language = localStorage.getItem('i18nextLng') || 'esPR';

    if (token) 
      config.headers.Authorization = `Bearer ${token}`;

    config.headers['Accept-Language'] =  language;

    return config;
  },
  (error) =>Promise.reject(error)
  
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>  Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;